import Rails from "@rails/ujs";
window.Rails = Rails;

if (!Rails.started) {
  Rails.start();
}
